module.exports = __webpack_public_path__ + "img/21-1.10173b9a.png";